import * as React from 'react';
import styled from 'styled-components';

interface IProps {
  text: string;
  style?: React.CSSProperties;
}

const Container = styled.div`
  display: inline-block;
  text-align: center;
  border-radius: 10px;
  padding: 5px;
  margin: 2px 2px;
  color: var(--color-secondary-text);
  background-color: var(--color-secondary-accent);
`;

export const Badge = (props: IProps): React.ReactElement => {
  return <Container style={props.style}>{props.text}</Container>;
};
